const CheckboxField = ({
  label,
  name,
  checked,
  onChange,
  hint = "",
  disabled = false,
}) => (
  <div>
    <label
      className={`group inline-flex items-start gap-2 text-[13px] ${
        disabled ? "cursor-not-allowed text-gray-400" : "cursor-pointer text-gray-700"
      }`}
    >
      <input
        type="checkbox"
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className="mt-0.5 h-4 w-4 cursor-pointer rounded accent-brand-600 disabled:cursor-not-allowed"
      />
      <span className={disabled ? "" : "transition-colors group-hover:text-gray-900"}>
        {label}
      </span>
    </label>
    {hint && <p className="ml-6 mt-1 text-[11px] text-gray-500">{hint}</p>}
  </div>
);

export default CheckboxField;
